export default __webpack_public_path__ + "static/media/prod1.ce20f805.jpeg";